import React, { useContext } from 'react';
import RequiredField from '../RequiredField';
import ApplicationContext from '../../context/ApplicationContext';

function Label(props) {
    const { labelID, disabled, labelName, isMandatory } = props;
    const { selectedLanguage } = useContext(ApplicationContext);
    return (
        <label htmlFor={labelID} className={`font-semibold text-sm flex items-center ${disabled ? 'text-[#818181]' : 'text-[#007EB4]'}`}>{labelName}
            {isMandatory && <span className={`${selectedLanguage === 'ar' ? 'mr-2' : 'ml-2 '}`}><RequiredField /></span>}
        </label>
    );
}

export default Label;